import React, { useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { StudentPicker } from "./StudentPicker";
import { GroupForm, emptyGroup, groupBody, levelOf } from "./GroupForm";

export const PlanEditor = ({ date, period, students, meta, initial, taken, onSaved, onCancel, onChipsChanged, onSchoolSet }) => {
  const [g, setG] = useState({ ...emptyGroup(), ...initial, level: levelOf(students, initial.student_ids || []),
    homework_items: initial.homework_items?.length ? initial.homework_items : (initial.homework ? [initial.homework] : [""]) });
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try {
      await api.put(`/teacher/diary/plans/${initial.id}`, { period: initial.period || period, date, ...groupBody(g) });
      toast.success("Plan updated");
      onSaved();
    } catch (e) { toast.error(e?.response?.data?.detail || "Could not save plan"); } finally { setBusy(false); }
  };
  return (
    <div className="space-y-4 rounded-2xl border-2 border-emerald-200 bg-white p-4" data-testid="plan-editor">
      <StudentPicker students={students} value={g.student_ids} onChange={(ids) => setG({ ...g, student_ids: ids })} onSchoolSet={onSchoolSet} taken={taken} />
      <GroupForm g={g} set={setG} students={students} meta={meta} onChipsChanged={onChipsChanged} />
      <div className="flex gap-2">
        <Button onClick={save} disabled={busy} className="bg-emerald-700 hover:bg-emerald-800" data-testid="plan-save">{busy && <Loader2 className="mr-1 h-4 w-4 animate-spin" />}Save plan</Button>
        <Button variant="outline" onClick={onCancel} data-testid="plan-cancel">Cancel</Button>
      </div>
    </div>
  );
};
